import * as React from "react";
import { styled } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import { PatientColorMap } from "../layout/patientColorMap";
import IconButton from "@mui/material/IconButton";

//region [[ Styles ]]

const OpenChatIconView = styled(IconButton)({
  //background: "#FFF",
  "& .custom-icon": {
    maxHeight: "180px",
  },
});

const OpenChat = styled(ChatIcon)({
  height: "1.5em",
  width: "1.5em",
  color: PatientColorMap.PrimaryLight,
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface OpenChatIconProps {
  className?: string;
  onClick?: () => void;
  imgUrlSrc?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const OpenChatIcon = ({ imgUrlSrc, ...props }: OpenChatIconProps) => {
  return (
    <OpenChatIconView className={props.className} onClick={props.onClick}>
      {imgUrlSrc ? (
        <img className="custom-icon" src={imgUrlSrc} alt={"open"} />
      ) : (
        <OpenChat />
      )}
    </OpenChatIconView>
  );
};
